<template>
  <div id="OrgEditHeaderQuotationCard">
    <div class="list-header">
      <div class="list-header-left ellipsis">
        <span>{{ orgInfo.departName }}</span>
      </div>
      <div class="list-header-right">
        <span>分享</span>
        <i class="iconfont icon-fenxiang"></i>
        <span>关注</span>
        <i class="iconfont icon-wujiaoxing"></i>
        <span>被关注：67</span>
      </div>
    </div>
    <div class="list-body">
      <div class="list-body-hidden-div">
        <img class="img-auto-size" id="departLogo" :src="getLogoImgUrl()" alt="" data-auto-width="60" data-auto-height="45">
      </div>
      <a data-title="上传" @click="showOrgUploadLogoWindow()" data-type="info" style="margin-top: 25px; height: 20px; line-height: 20px; float: left; padding: 0 10px;">
          <i style="position: relative; bottom: -10px;color: red;cursor: pointer;" class="icon iconfont icon-ico_pic cursor"></i>
      </a>
      <ul class="ul-company-menu">
        <li>企业简介</li>
        <li>企业商圈</li>
        <li>企业资质</li>
        <li>企业产品</li>
        <li>企业服务</li>
        <li>企业团队</li>
        <li class="ul-company-menu-li">+</li>
      </ul>
    </div>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';
import moment from 'moment';
export default {
  name: 'OrgEditHeaderQuotationCard',
  props: {
    orgInfo: {},
    user: {}
  },
  methods: {
    showOrgUploadLogoWindow() {
      eventBus.$emit('showOrgUploadLogoWindow', '');
    },
    getLogoImgUrl() {
      let m = moment();
      return this.orgInfo.departLogo ? baseURL + this.orgInfo.departLogo + '?m=' + m : baseURL + '/static/img/147x147.png';
    }
  }
};
</script>
<style scoped lang="less">
  #ebOrgEditHeaderCard {
    ul, li {
      list-style: none;
    }
    .list-header {
      display: flex;
      flex-wrap: wrap;
    }
    .list-header-left {
      height: 52px;
      width: 60%;
      line-height: 52px;
      span {
        font-size: 14px;
        font-weight: bold;
        text-indent: 100px;
        color: black;
      }
    }
    .list-header-right {
      padding-top: 15px;
      width: 39%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      span {
        color: black;
      }
      button {
        margin-top: -5px;
        margin-right: 20px;
        margin-left: 60px;
      }
      i {
        color: red;
        margin-right: 25px;
      }
    }
    .list-body {
      display: flex;
      flex-wrap: wrap;
      .list-body-hidden-div {
        margin-right: 0px;
        width: 60px;
        height: 45px;
        margin-top: 9px;
        display: flex;
        .img-auto-size{
          margin:auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .ul-company-menu {
      float: left;
      margin-top: 31px;
      margin-bottom: 0px;
      margin-left: 50px;
      padding-left: 0px;
      li {
        border: 1px solid #CCCCCC;
        width: 74px;
        background-color: white;
        float: left;
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        margin-right: 50px;
        box-shadow: 2px 2px 2px #cccccc;
        font-size: 12px;
      }
      .ul-company-menu-li {
        font-weight: bold;
        color: red;
      }
    }
  }
</style>
